module.exports = __webpack_public_path__ + "img/license-backup.7da579eb.png";